import React, { useState, useRef } from 'react';
import '../assets/styles/videoSection.css';

const VideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlayVideo = () => {
    setIsPlaying(true);
    videoRef.current.play();
  };

  const handlePauseVideo = () => {
    setIsPlaying(false);
  };

  return (
    <div className="videoSection">
      {!isPlaying && (
        <div className="thumbnail-container">
          <img
            src="https://images.unsplash.com/photo-1605647533135-51b5906087d0?q=80&w=2970&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Video Thumbnail"
            className="thumbnail"
            onClick={handlePlayVideo}
          />
          <div className="overlay"></div>
          <div className="overlay-text">
            show video
          </div>
          <div className="play-button" onClick={handlePlayVideo}></div>
        </div>
      )}
      <video
        ref={videoRef}
        id="video"
        controls
        style={{ display: isPlaying ? 'block' : 'none' }}
        width="100%"
        onPause={handlePauseVideo}
      >
        <source src="https://66c5466408eb95a5e8d86135--sunny-daffodil-e5c281.netlify.app/sample.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoSection;